var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReturned = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.96254 0.5 0.5 2.96232 0.5 6C0.5 9.03768 2.96254 11.5 6 11.5C9.03746 11.5 11.5 9.03746 11.5 6C11.5 2.96254 9.03768 0.5 6 0.5Z",
    fill: "#1B84FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05281 8.07606C7.93855 8.19027 7.78361 8.25444 7.62205 8.25444C7.46049 8.25444 7.30555 8.19027 7.19129 8.07606L5.57029 6.45398C5.51224 6.39603 5.46651 6.32692 5.43586 6.25082C5.40522 6.17472 5.39029 6.09321 5.39197 6.01119C5.39197 6.00732 5.39197 6.00367 5.39197 5.9998V2.41643C5.39197 2.25483 5.45617 2.09985 5.57043 1.98559C5.6847 1.87132 5.83968 1.80713 6.00127 1.80713C6.16287 1.80713 6.31784 1.87132 6.43211 1.98559C6.54637 2.09985 6.61057 2.25483 6.61057 2.41643V5.77078L8.0541 7.21432C8.11063 7.27097 8.15544 7.3382 8.18597 7.41218C8.21651 7.48616 8.23216 7.56542 8.23204 7.64545C8.23192 7.72548 8.21603 7.8047 8.18528 7.87859C8.15452 7.95247 8.10951 8.01957 8.05281 8.07606Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReturned);
export default ForwardRef;